/* Class-code student signup (2026-10-27): /join and /join/<code>, the page a
   teacher's class link opens. Live 2026-10-28 (its backend, the PreSignUp
   code check and the PostConfirmation school lookup, went live 2026-10-27).
   JOIN_LIVE switches the page's invite-link buttons on the teacher dashboard. */

export const JOIN_LIVE = true;
export const JOIN_PATH = '/join';

// Same cleanup as claude-student-api normalizeJoinCode, minus the legacy dash.
export const cleanJoinCode = (raw) => String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);

export const joinLink = (code) => `${window.location.origin}${JOIN_PATH}/${cleanJoinCode(code)}`;
